<template>
	<a
		v-if="showBadge"
		class="c-header__subscription-badge"
		:href="subscriptionBadgeLink"
		target="_blank"
		rel="noopener"
	>
		{{ subscriptionBadgeLabel }}
	</a>
</template>

<script>
export default {
	name:     'SubscriptionBadge',
	computed: {
		subscriptionBadgeLink() {
			const link = this.$arenaConfig.payment?.subscriptionBadgeLink;
			return typeof link === 'string' && link.trim() !== '' ? link.trim() : null;
		},
		subscriptionBadgeLabel() {
			return this.$Helpers.getTranslatedContent(this.$arenaConfig.payment?.subscriptionBadgeLabel) || null;
		},
		showBadge() {
			return !!this.subscriptionBadgeLink && !!this.subscriptionBadgeLabel;
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@sass/variables';

/* stylelint-disable */
.c-header__subscription-badge {
	display: flex;
	align-items: center;
	font-size: 14px;
	font-weight: 500;
	line-height: 1;
	color: var(--color-grey-900);
	text-decoration: none;
	background-color: var(--color-grey-050);
	padding: $sp3 $sp4;
	border-radius: 100px;
	height: 36px;
}

/* stylelint-enable */
</style>
